export const ATTACHMENTS_APPLICATION = 'landing-page';
export const ATTACHMENTS_TYPE = 'Community';
export const ATTACHMENTS_ID = 'documents';
